import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {NzSelectComponent} from 'ng-zorro-antd/select';
import {IFoodGroupIngredient, INutritionalProperties} from '../../models/food-group';
import {cloneDeep} from 'lodash';
import {IIngredientCategory} from '../../interfaces/database/database.interface';
import {IIngredient, IngredientsAction, IngredientState} from '../../models/ingredient';
import {IIndicatorsPatientConsultation, IMeasurementUnit} from '../../models/measurement';
import {IngredientCalculationService} from '../../services/ingredient-calculation/ingredient-calculation.service';
import {Store} from '@ngxs/store';
import {firstValueFrom, Observable} from 'rxjs';
import {NgForm} from '@angular/forms';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {FoodGroupService} from '../../services/food-group/food-group.service';
import {MealPlanTypeEnum} from '../../models/meal-plans';
import {MealPlanBuilderState} from '../../models/meal-plan-builder';
import {PatientAction, PatientState} from '../../models/patient';
import {IngredientService} from '../../services/ingredient/ingredient.service';

@Component({
  selector: 'app-form-ingredient',
  templateUrl: './form-ingredient.component.html',
  styleUrls: ['./form-ingredient.component.scss'],
  animations: [fadeInAnimation]
})
export class FormIngredientComponent implements OnInit, OnChanges {
  @Input() mealPlanType: MealPlanTypeEnum;
  @Input() ingredient: Partial<IFoodGroupIngredient> = null;
  @Input() hasCategoryFilter: boolean;
  @Input() hasIngredientName: boolean;
  @Input() hasNutritionalProperties: boolean;
  @Input() hasMeasurementUnit: boolean;
  @Input() hasUnits: boolean;
  @Input() hasActionButtons: boolean;
  @Input() showForm: boolean;
  @Input() isIngredientEdition = false;
  @Input() searchOnOpen = false;
  @Output() cancel: EventEmitter<boolean> = new EventEmitter();
  @Output() save: EventEmitter<Partial<IFoodGroupIngredient>> = new EventEmitter();
  @ViewChild('categoryIngredientSelect') categoryIngredientSelect: NzSelectComponent;
  @ViewChild('ingredientForm') ingredientForm: NgForm;
  ingredients$: Observable<IIngredient[]> = this.store.select<IIngredient[]>(IngredientState.getIngredients);
  categoryIngredientMode = false;
  ingredientCategories: IIngredientCategory[] = [];
  measureUnits: IMeasurementUnit[];
  selectedIngredientCategories: IIngredientCategory[] = [];
  selectedIngredientCategoriesIds: string[] = [];
  ingredients: IIngredient[];
  ingredientEdit: Partial<IFoodGroupIngredient>;
  selectedIngredient: IIngredient;
  unitsInterval: any;
  // Variables para la búsqueda de ingredientes
  batchSizeIngredients = 20;
  totalBatchesIngredient = 0;
  ingredientNameSearch: string;
  isLoadingIngredients = false;
  isLoadingFirstIngredients = false;
  searchIntervalIngredient: any;
  finishSearchIngredients = false;
  searchIngredientPreviewValue = '';
  constructor(
    private store: Store,
    private ingredientCalculationService: IngredientCalculationService,
    private messageAlertService: MessageAlertService,
    private foodGroupService: FoodGroupService,
    private ingredientService: IngredientService
  ) {
  }

  ngOnInit(): void {
    this.defaultIngredientValues();
    this.initializeIngredientVariables().then();
    this.searchIngredientPreviewValue = '';
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (!changes.ingredient) return;
    if (!this.ingredient) return;
    // Llenar formulario a editar
    this.isIngredientEdition = true;
    this.selectedIngredient = cloneDeep(await firstValueFrom((this.store.selectOnce(IngredientState.getSelectedIngredient))));
    this.ingredientEdit = cloneDeep(this.ingredient);
  }

  defaultIngredientValues(): void {
    this.ingredientEdit = cloneDeep({
      ingredientId: null,
      ingredientName: null,
      measure: {
        _id: null
      },
      units: 1,
      category: null,
      nutritionalProperties: null
    });
  }

  /**
   * Inicializa las variables para los ingredientes
   */
  async initializeIngredientVariables(): Promise<void> {
    this.measureUnits = cloneDeep(await firstValueFrom(this.store.selectOnce(IngredientState.getMeasureUnits)));
    // TODO: INcluir calculo de nutrientes en BlockPeriod para porcion
    // this.measureUnits.push({
    //   _id: 'porcion',
    //   name_es: 'Porción',
    //   namePlural_es: 'Porciones',
    //   symbol_es: 'porción',
    //   metadata: {
    //     id: 'porcion'
    //   }
    // });
    this.ingredientCategories = cloneDeep(await firstValueFrom(this.store.selectOnce(IngredientState.getIngredientCategories)));
    // Asignar colores a las categorías de los ingredientes
    this.ingredientCategories.forEach(category => {
      category.color = this.foodGroupService.setIngredientCategoryColor(category.name);
    });
    this.ingredients = cloneDeep(await firstValueFrom(this.store.selectOnce(IngredientState.getIngredients)));
  }

  /**
   * Al cambiar el valor del select múltiple de categorías de ingredientes
   */
  onSelectIngredientCategories(categoryIds: string[]): void {
    this.selectedIngredientCategories = [];
    categoryIds.forEach((tagId: string) => {
      const index: number = this.ingredientCategories.findIndex((category: IIngredientCategory) => category._id === tagId);
      if (index !== -1) {
        this.selectedIngredientCategories.push(this.ingredientCategories[index]);
        this.categoryIngredientSelect.setOpenState(false);
      }
    });
  }

  /**
   * Método para remover una categoría de los ingredientes
   */
  onRemoveIngredientCategory(id: string): void {
    const index = this.selectedIngredientCategories.findIndex(cat => cat._id === id);
    if (index !== -1) {
      this.selectedIngredientCategories.splice(index, 1);
      this.selectedIngredientCategoriesIds.splice(index, 1);
      // Actualizar la lista de ingredientes
      // this.getFirstIngredientBatch();
    }
  }



  /**
   * Método para habilitar/deshabilitar el select para elegir categorías de ingredientes
   */
  onToggleCategoryIngredientEditMode(mode: boolean): void {
    this.categoryIngredientMode = mode;
    if (!mode) {
      // Actualizar la lista de ingredientes
      // this.getFirstIngredientBatch();
      return;
    }
    setTimeout(() => {
      if (this.categoryIngredientSelect) {
        this.categoryIngredientSelect.setOpenState(true);
      }
    }, 200);
  }

  /**
   * Obtiene el primer lote de ingredientes (para el select)
   */
  async getFirstIngredientBatch(): Promise<void> {
    this.totalBatchesIngredient = 0;
    this.finishSearchIngredients = false;
    const categoryId: string = this.selectedIngredientCategoriesIds?.length > 0 ? this.selectedIngredientCategoriesIds[0] : '';
    await firstValueFrom(this.store.dispatch(new IngredientsAction.Get('', categoryId)));
  }

  /**
   * Trae los resultados de búsqueda para los ingredientes
   * @param $event evento de búsqueda del input
   */
  async onSearchIngredient($event): Promise<void> {
    if (this.searchOnOpen) {
      this.searchIngredientPreviewValue = 'something';
    }
    // Evitar que haga una petición la primera vez que se abre el select
    if (!this.searchIngredientPreviewValue) {
      this.searchIngredientPreviewValue = 'something';
      if (this.selectedIngredient) {
        this.store.dispatch(new IngredientsAction.RemoveSelectedUserListIngredient());
      }
      return;
    }
    // Búsqueda
    this.searchIngredientPreviewValue = $event;
    this.isLoadingFirstIngredients = true;
    if (this.searchIntervalIngredient) {
      clearInterval(this.searchIntervalIngredient);
    }
    this.searchIntervalIngredient = setTimeout(async () => {
      this.finishSearchIngredients = false;
      this.ingredientNameSearch = $event;
      const categoryId: string = this.selectedIngredientCategoriesIds?.length > 0 ? this.selectedIngredientCategoriesIds[0] : '';
      await firstValueFrom((this.store.dispatch(new IngredientsAction.Get(this.ingredientNameSearch, categoryId))));
      this.isLoadingFirstIngredients = false;
    }, 400);
  }

  /**
   * Guarda el valor seleccionado
   * @param id id del ingrediente
   */
  async onChooseIngredient(id: string): Promise<void> {
    try {
      // Resetea las unidades en 1
      this.ingredientEdit.units = 1;
      // Establece por default la unidad de medida que tiene ligada
      this.ingredients = cloneDeep(await firstValueFrom((this.store.selectOnce(IngredientState.getIngredients))));
      const ingredients: IIngredient[] = [...this.ingredients];
      const index: number = ingredients.findIndex((ingredient: IIngredient) => ingredient._id === id);
      if (index === -1) return;
      this.selectedIngredient = cloneDeep(ingredients[index]);
      this.ingredientEdit.ingredientName = ingredients[index]?.name;
      this.ingredientEdit.category = this.ingredientCategories.find((cat: IIngredientCategory) => cat._id === ingredients[index].ingredientCategoryId);
      this.ingredientEdit.measure = cloneDeep(ingredients[index]?.unitOfMeasurement);
      const data: Partial<INutritionalProperties> = this.ingredientCalculationService.calculateNutritionalProperties(
        this.selectedIngredient,
        this.measureUnits,
        this.ingredientEdit.measure?._id,
        this.ingredientEdit.units
      );
      this.ingredientEdit.nutritionalProperties = data;
      this.ingredientEdit.smae = {
        portion: this.ingredientEdit?.nutritionalProperties?.portions
      };

      // let measurement: IMeasurementUnit;
      // measurement = this.measureUnits.find(m => this.mealPlanType === MealPlanTypeEnum.SMAE ?  m.name_es === 'Porción' :  m.name_es === 'Gramo');
      // if (measurement) this.ingredientEdit.measure._id = measurement._id;
      const canShowAllergicMode: boolean = await firstValueFrom(this.store.selectOnce(MealPlanBuilderState.getCanShowAllergicMode));
      if (canShowAllergicMode) {
        // todo se llama al servicio de ingredient
        const dislikes: string[] = await this.ingredientService.getDislikesIngredientsPatient();
        const allergies: string[] = await this.ingredientService.getAllergiesPatient();
        this.ingredientEdit.isDislike = dislikes.includes(id);
        this.ingredientEdit.isAllergic = allergies.includes(id);
      }
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Guarda el valor seleccionado
   * @param id id del ingrediente
   */
  async onChooseMeasure(id: string): Promise<void> {
    // Establece la unidad de medida
    const measures = cloneDeep(this.measureUnits);
    const index = measures.findIndex(measure => measure._id === id);
    this.ingredientEdit.measure = cloneDeep(measures[index]);
    // Resetea las unidades en 1
    this.ingredientEdit.units = 1;
    this.ingredientEdit.nutritionalProperties = this.ingredientCalculationService.calculateNutritionalProperties(
      this.selectedIngredient, this.measureUnits, this.ingredientEdit.measure?._id, this.ingredientEdit.units);
    this.ingredientEdit.smae = {
      portion: this.ingredientEdit.nutritionalProperties?.portions
    };
  }

  /**
   * Al cambiar el valor de las unidades
   * @param units Cantidad en unidades
   */
  onChangeUnits(units: any): void {
    if (this.unitsInterval) {
      clearInterval(this.unitsInterval);
    }
    this.unitsInterval = setTimeout(() => {
      if (units < 0) {
        this.ingredientEdit.units = 1;
      }
      this.ingredientEdit.nutritionalProperties = this.ingredientCalculationService.calculateNutritionalProperties(
        this.selectedIngredient, this.measureUnits, this.ingredientEdit.measure?._id, this.ingredientEdit.units);
      this.ingredientEdit.smae = {
        portion: this.ingredientEdit.nutritionalProperties?.portions
      };
    }, 200);
  }

  /**
   * Cancela la edición para agregar un ingrediente
   */
  onCancelEditIngredient(): void {
    this.onCancel();
    // this.resetIngredientForm();
  }

  /**
   * Método para habilitar/deshabilitar el formulario para agregar ingrediente
   */
  onCancel(): void {
    this.cancel.emit(true);
  }

  /**
   * Agrega un renglón para añadir un ingrediente
   */
  async onAddIngredient(): Promise<void> {
    /* if (this.verifyIfIngredientExists()) {
      this.messageAlertService.createMessage('warning', 'No se puede volver a añadir el mismo ingrediente, selecciona otro');
      return;
    } */
    if (this.ingredientEdit.units <= 0) {
      this.messageAlertService.createMessage('warning', 'La cantidad de unidades debe ser mayor a 0');
      return;
    } else if (this.ingredientEdit.units < 0.01) {
      this.messageAlertService.createMessage('warning', 'La cantidad de unidades debe ser mayor a 0.01');
      return;
    }
    if (!this.ingredientForm.form.valid) {
      this.ingredientForm.form.markAllAsTouched();
      this.messageAlertService.createMessage('error', this.messageAlertService.messages.incompleteData);
      return;
    }
    const ingredient: IFoodGroupIngredient = cloneDeep(this.ingredientEdit);
    if (ingredient.measure?._id === 'porcion') {
      const gram = this.measureUnits.find(mu => mu.symbol_es === 'g');
      ingredient.measure = gram;
      ingredient.units = ingredient.nutritionalProperties.portions * ingredient.nutritionalProperties.netWeight;
    }
    await firstValueFrom((this.store.dispatch(new IngredientsAction.AddSelectedIngredient(this.selectedIngredient))));
    this.save.emit(ingredient);
  }

  /**
   * Confirma la edición del ingrediente que se está editando
   */
  async onModifyIngredient(): Promise<void> {
    if (this.ingredientEdit.units <= 0) {
      this.messageAlertService.createMessage('warning', 'La cantidad de unidades debe ser mayor a 0');
      return;
    } else if (this.ingredientEdit.units < 0.01) {
      this.messageAlertService.createMessage('warning', 'La cantidad de unidades debe ser mayor a 0.01');
      return;
    }
    if (!this.ingredientForm.form.valid) {
      this.ingredientForm.form.markAllAsTouched();
      this.messageAlertService.createMessage('error', this.messageAlertService.messages.incompleteData);
      return;
    }
    const ingredient = cloneDeep(this.ingredientEdit);
    if (ingredient.measure?._id === 'porcion') {
      const gram = this.measureUnits.find(mu => mu.symbol_es === 'g');
      ingredient.measure = gram;
      ingredient.units = ingredient.nutritionalProperties.portions * ingredient.nutritionalProperties.netWeight;
    }
    await firstValueFrom((this.store.dispatch(new IngredientsAction.AddSelectedIngredient(this.selectedIngredient))));
    this.save.emit(ingredient);
  }

  /**
   * Guardar automáticamente las categorías del select al cerrar las opciones
   * @param action true para abrir, falso para cerrar
   */
  onOpenChangeCategoriesSelect(action: boolean): void {
    if (action) return;
    this.onToggleCategoryIngredientEditMode(false);
  }

}
